import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {tap} from 'rxjs/operators';

import {ClaimType} from '../../../../../+ess/claims/claims.interfaces';
import {ESSService} from '../../../../../+ess/employee-self.service';
import {Destroyable} from '../../../../../destroyable.component';
import {createClaimTypeTree} from '../../../../claim-form/claim-form-utils';
import {TreeNode} from '../../../../ui';
import {Variable} from '../../../workflow-v2.interface';

@Component({
  selector: 'gp-claim-element',
  templateUrl: './claim-element.component.html',
  styleUrls: ['./claim-element.component.scss']
})
export class ClaimElementComponent extends Destroyable implements OnInit {

  @Input()
  public cliRegId: number;

  @Input()
  public contractId: number;

  @Input()
  public requestVariable: Variable;

  public claimForm: UntypedFormGroup;
  public claimTypes: ClaimType[];
  public claimTypeTree: Array<TreeNode<any>>;

  @Output()
  private requestUpdate: EventEmitter<Variable> = new EventEmitter();

  constructor(private essService: ESSService,
              private changeDetectorRef: ChangeDetectorRef,
              private formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit(): void {
    this.initClaimParams();
  }

  private initClaimParams() {
    this.initClaimForm();
    this.essService.getClaimTypes(this.cliRegId).pipe(
      tap((claimTypes: ClaimType[]) => {
        this.claimTypes = claimTypes;
        this.claimTypeTree = createClaimTypeTree(this.claimTypes);

        this.changeDetectorRef.markForCheck();
      })
    ).subscribe();
  }

  private initClaimForm() {
    this.claimForm = this.formBuilder.group({
      name: ['', Validators.required],
      requestLimit: ['', ''],
      value: ['', Validators.required],
      transId: ['', ''],
      unitTransId: ['', ''],
      comment: ['', ''],
      beginDate: ['', ''],
      endDate: ['', ''],
      evType: ['', ''],
      values: ['', ''],
      cliEmpId: ['', ''],
      firstName: ['', ''],
      lastName: ['', ''],
      contractId: ['', ''],
      payPeriodTransId: ['', '']
    });
  }

  public onRequestUpdate(event: Variable) {
    this.requestUpdate.emit(event);
  }
}
